const Snowplow = {
  domainUserIdCookie: 'lux_sp_domain_user_id',
  sessionIdCookie: 'lux_sp_session_id',
  sessionIdxCookie: 'lux_sp_session_idx',
  postPath: '/com.luxgroup/tp2',
}
export default Snowplow
